import classnames from "classnames";
import { ReactComponentElement } from "react";
import styled from "styled-components";

import {
  background,
  ThemeProps,
  ThemeWrapperProps
} from "features/common/themes";

import styles from "./RowLayout.module.scss";

type Props = {
  depth?: 0 | 1 | 2;
  active?: boolean;
  onClick?: () => void;
  children: {
    title: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
    indicator:
      | ReactComponentElement<any, any>
      | ReactComponentElement<any, any>[];
  };
};

const ThemeWrapper = styled.div<ThemeWrapperProps>`
  ${({ theme }: ThemeProps) => `
  .${styles.active} {
     ${background(theme["primary-low-surface"])}
  }
  .${styles.wrapper}:hover:not(.${styles.active})  {
    color: ${theme["primary-high-content"]}
  }
  `};
`;

export default function RowLayout({
  depth,
  active,
  onClick,
  children: { title, indicator }
}: Props) {
  return (
    <ThemeWrapper className="">
      <button
        onClick={onClick}
        className={classnames(styles.wrapper, {
          [styles.depthTop]: depth === 0,
          [styles.depthMid]: depth === 1,
          [styles.depthBtm]: depth === 2,
          [styles.active]: active
        })}
      >
        <div className={styles.title}>{title}</div>
        <div className={styles.indicator}>{indicator}</div>
      </button>
    </ThemeWrapper>
  );
}
